import { APP_REDUCER_STATUS, appHomePage, appPages, appStatus, initSite } from '@/store/reducerApp';
import { useEffect } from 'react';
import { getCookieConsentValue } from 'react-cookie-consent';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';

import type { AppDispatch } from './store/store';

import { SplashScreen } from './components/loading-screen';
import { initAnalytics } from './libs/tracking/tracking';
import { ErrorPage } from './pages';

const AppLoader = () => {
  const dispatch = useDispatch<AppDispatch>();
  const status = useSelector(appStatus);
  const pages = useSelector(appPages);
  const homePage = useSelector(appHomePage);
  const location = useLocation();

  useEffect(() => {
    const isConsent = getCookieConsentValue();

    if (isConsent === 'true') {
      initAnalytics();
    }
  }, []);

  if (status === APP_REDUCER_STATUS.NOT_INITIATED) {
    dispatch(initSite());
    return <SplashScreen />;
  } else if (status === APP_REDUCER_STATUS.LOADING) {
    return <SplashScreen />;
  } else if (status === APP_REDUCER_STATUS.ERROR) {
    return <ErrorPage />;
  }

  const normalizeUri = (uri: string) => uri.replace(/\/+$/, '');
  const defaultPage =
    pages?.find((page) => normalizeUri(page.uri) === normalizeUri(location.pathname))?.uri ||
    homePage;
  return <Navigate to={defaultPage || location.pathname} replace />;
};

export default AppLoader;
